import styled from "styled-components";

export const BOX_WIDTH = 314;
export const BOX_HEIGHT = 42;
export const LIST_COLUMN_WIDTH = 333;
export const LIST_COLUMN_HEIGHT = 463;
export const DRAG_HANDLE_CLASSNAME = "dragHandle";

export const FilterPanelContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: left;
  position: fixed;
  z-index: 10000;

  padding-left: 23px;
  padding-right: 23px;
  padding-top: 10px;

  top: 50%;
  left: 50%;
  margin: -300px 0px 0px -750px;
  width: 1500px;
  height: 583px;

  background: #ffffff;
  border: 2px solid #4eab00;
  box-sizing: border-box;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
`;

export const FilterPanelHeader = styled.div`
  width: 100%;
  height: 24px;

  margin-bottom: 10px;

  font-size: 18px;
  line-height: 24px;
  text-align: start;

  color: #525252;
  text-transform: uppercase;
`;

export const DragHandle = styled.div.attrs(() => ({
  className: DRAG_HANDLE_CLASSNAME,
}))`
  cursor: move;
  width: 100%;
  height: 100%;
`;

interface IFlexItemProps {
  flex?: number;
  alignItems?: string;
  justifyContent?: string;
  alignSelf?: string;
  width?: number;
  height?: number;
}

export const FlexItem = styled.div`
  flex: ${(props: IFlexItemProps) => props.flex || "0 0 auto"};
  display: flex;
  flex-direction: column;
  align-items: ${(props: IFlexItemProps) => props.alignItems || "flex-start"};
  justify-content: ${(props: IFlexItemProps) => props.justifyContent || "center"};
  align-self: ${(props: IFlexItemProps) => props.alignSelf || "auto"};
  width: ${(props: IFlexItemProps) => (props.width ? `${props.width}px` : "auto")};
  height: ${(props: IFlexItemProps) => (props.height ? `${props.height}px` : "auto")};
`;

export const Column = styled(FlexItem)`
  flex-direction: column;
  flex-basis: ${(props: IFlexItemProps) => (props.width ? `${props.width}px` : "auto")};
`;

export const Row = styled(FlexItem)`
  flex-direction: row;
  flex-basis: ${(props: IFlexItemProps) => (props.height ? `${props.height}px` : "auto")};
`;

export const FilterPanelButtonRow = styled(Row)`
  margin-left: auto;
  margin-top: 15px;
  margin-bottom: 15px;
`;

export const ScrollBarMarginRight = styled.div`
  margin-right: 19px;
`;

export const Gap = styled.div`
  width: ${(props: { width: string }) => `${props.width}px`};
`;

export const Box = styled.div`
  width: ${BOX_WIDTH}px;
  height: ${BOX_HEIGHT}px;
  border-top: 1px solid #78899a;
  border-left: 1px solid #78899a;
  border-right: 1px solid #78899a;
  padding: 2px;

  display: flex;
  align-items: center;

  :last-of-type {
    border-bottom: 1px solid #78899a;
  }
`;

export const HeaderBox = styled(Box)`
  padding-left: 15px;
  background: #d7dadd;
  font-weight: bold;
  color: #3a4855;
  text-transform: uppercase;
`;


export const ListBox = styled.div`
  // width: ${BOX_WIDTH}px;
  height: ${BOX_HEIGHT}px;
  border-bottom: 1px solid #78899a;
  // border-left: 1px solid #78899a;
  // border-right: 1px solid #78899a;
  padding: 2px;

  display: flex;
  align-items: center;

  :last-of-type {
    border-bottom: none;
  }
`;

export const FilterComponentHeader = styled.div`
  color: black;
`;

export const EmptyFilterInput = styled.input`
  width: calc(100% - 6px);
  height: 34px;
  border: 1px solid #78899a;
`;
